/*
 * Cliente del antibot.
 *
 * Reglas que no se pueden romper:
 * - El challenge se pide en la PRIMERA interaccion, no en la carga: asi la
 *   pagina sigue siendo cacheable (ni MicroPageCache ni el fastcgi_cache
 *   discriminan por visitante, asi que un challenge horneado en el HTML se
 *   serviria compartido y el primero que enviara lo consumiria para todos) y
 *   ademas el tiempo minimo mide lo que importa: lo que se tarda en rellenar,
 *   no lo que la pestana lleva abierta.
 * - Nada de comentarios de linea dentro de atributos HTML: el middleware
 *   MinifyHtml aplasta el HTML final —incluidos los atributos, que no protege
 *   como si hace con <script> y <style>— y un // se comeria el resto.
 * - Si un auto-submit se dispara con el challenge en vuelo, se ENCOLA el envio
 *   hasta que la promesa resuelva, en lugar de salir sin token.
 *
 * El esquema del token (v) es el de config/antibot.php (schema_version). El
 * verificador acepta la version actual y la anterior mientras
 * accept_legacy_schema siga en true, que es lo que da margen para desplegar
 * este fichero y el servidor en cualquier orden.
 *
 * ═══ ESTE FICHERO TIENE UN ESPEJO EXACTO EN public/js/antibot-form.js ═══
 *
 * Las landings de Commerce (site/comercio/layout.blade.php) y de Verify
 * (saas/services/otp/public/layout.blade.php) son standalone: su layout NO
 * carga NINGUN bundle de Vite —ni almc.js ni public-core.js—, asi que por esta
 * via el modulo no llega a sus formularios y cada envio saldria sin token.
 * Comprobado renderizando por HTTP, no suponiendo: ninguna de las dos paginas
 * emite un solo /build/ en su HTML.
 *
 * La alternativa limpia —una entrada propia en vite.config.js— exige
 * reconstruir el manifest para que esas dos paginas se puedan siquiera
 * RENDERIZAR (@vite lanza si la entrada no esta en el manifest), asi que
 * cualquier arbol con un build viejo se quedaria sin poder abrirlas. Por eso
 * se sirve como <script> clasico desde public/, igual que ya hace ese layout
 * con Alpine (public/vendor/alpinejs-*.js).
 *
 * Los dos ficheros deben tener el MISMO CONTENIDO, y lo fija
 * tests/Feature/AntiBot/CommerceDemoWiringTest.php. Si tocas este:
 *   cp resources/js/antibot/antibot-form.js public/js/antibot-form.js
 */
(function () {
  'use strict';

  var SEED_URL = '/_ab/seed';
  var SCHEMA_VERSION = 2;

  function issue(seedUrl, profile, route) {
    return fetch(seedUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ profile: profile, route: route })
    }).then(function (r) {
      if (!r.ok) throw new Error('seed ' + r.status);
      return r.json();
    });
  }

  function encodeToken(state) {
    return btoa(JSON.stringify({
      v: SCHEMA_VERSION,
      challenge_id: state.challengeId,
      seed: state.seed,
      nonce: state.nonce || ''
    }));
  }

  function attach(form, opts) {
    if (!form || form.__antibotAttached) return;
    form.__antibotAttached = true;

    opts = opts || {};

    var seedUrl = opts.seedUrl || SEED_URL;
    var state = { challengeId: null, seed: null, nonce: '', pending: null, liberando: false };

    function ensure() {
      if (state.pending) return state.pending;

      state.pending = issue(seedUrl, opts.profile, opts.route).then(function (data) {
        state.challengeId = data.challenge_id;
        state.seed = data.seed;

        if (data.csrf_token) {
          var input = form.querySelector('input[name="_token"]');
          if (input) input.value = data.csrf_token;
          var meta = document.querySelector('meta[name="csrf-token"]');
          if (meta) meta.setAttribute('content', data.csrf_token);
        }

        return data;
      }).catch(function () {
        /*
         * Fallo al emitir: no se bloquea al usuario. El servidor decidira, y en
         * los perfiles publicos hay intersticial como red de seguridad.
         */
        state.pending = null;

        return null;
      });

      return state.pending;
    }

    /*
     * El listener es {once:true} porque solo hace falta la primera vez. Por eso
     * hay que volver a ARMARLO cuando la pestana se restaura: sin esta funcion,
     * un `pageshow` persistido limpiaba el estado y dejaba el formulario sin
     * forma de pedir challenge nunca mas, es decir, enviando siempre sin token.
     */
    function armar() {
      form.addEventListener('focusin', ensure, { once: true });
    }

    function setToken() {
      if (!state.challengeId) return;

      var field = form.querySelector('input[name="antibot_token"]');

      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'antibot_token';
        form.appendChild(field);
      }

      field.value = encodeToken(state);
    }

    armar();

    /*
     * bfcache y pestanas restauradas: el challenge que hubiera puede haber
     * vencido (TTL de 8 min) o haberse consumido ya en la primera vida de la
     * pagina, asi que se descarta y se rearma.
     */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;

      state.pending = null;
      state.challengeId = null;
      state.seed = null;
      state.liberando = false;
      armar();
    });

    form.addEventListener('submit', function (ev) {
      /*
       * Este es el envio que hemos relanzado nosotros al resolverse la promesa.
       * Sin esta bandera, cuando la emision falla el token sigue sin estar y el
       * handler vuelve a interceptar, a pedir seed y a reenviar: un bucle
       * infinito que convierte un fallo del endpoint en un flood contra el
       * propio endpoint.
       */
      if (state.liberando) {
        state.liberando = false;

        return;
      }

      if (state.challengeId) {
        setToken();

        return;
      }

      /*
       * Con el challenge en vuelo (o sin pedir), el envio se ENCOLA. Es el caso
       * del auto-submit —el 2FA envia solo al sexto digito— que de otro modo
       * saldria sin token por carrera con la promesa.
       */
      ev.preventDefault();

      ensure().then(function () {
        setToken();
        state.liberando = true;

        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });
  }

  /*
   * Token suelto, para lo que NO es un submit de formulario.
   *
   * El reenvio del codigo 2FA es un fetch con su propio FormData construido a
   * mano: attach() no lo ve nunca. Sin esta via, esa ruta anotaria `would_block`
   * en el 100 % de los reenvios legitimos y su contador no diria nada — que es
   * justo el ruido que los overrides de tiempo minimo existen para quitar.
   *
   * Devuelve null si la emision falla: quien llama envia igual, porque los
   * perfiles de autenticacion son fail-open por invariante.
   */
  function issueToken(profile, route, seedUrl) {
    return issue(seedUrl || SEED_URL, profile, route).then(function (data) {
      return encodeToken({ challengeId: data.challenge_id, seed: data.seed, nonce: '' });
    }).catch(function () {
      return null;
    });
  }

  /*
   * Enganche por atributos: <form data-antibot-profile="..." data-antibot-route="...">
   *
   * Existe para que una vista no tenga que llevar un <script> propio. El
   * cableado por script inline en la vista NO servia en las pantallas de auth:
   * su unico @stack('scripts') vive en el <head> (partials/saheadnoindex), asi
   * que el script correria antes de que los formularios existan y antes de que
   * este mismo modulo se haya ejecutado — un no-op perfecto y silencioso.
   */
  function autoAttach(root) {
    var forms = (root || document).querySelectorAll('form[data-antibot-profile]');

    for (var i = 0; i < forms.length; i++) {
      attach(forms[i], {
        profile: forms[i].getAttribute('data-antibot-profile'),
        route: forms[i].getAttribute('data-antibot-route')
      });
    }
  }

  window.AntibotForm = { attach: attach, autoAttach: autoAttach, issueToken: issueToken };

  /*
   * Se engancha AQUI MISMO, sin esperar a DOMContentLoaded, y eso es
   * deliberado: este modulo viaja en un bundle de Vite, que es un
   * <script type="module"> y por tanto ya diferido — cuando se ejecuta, el HTML
   * esta parseado entero y los formularios existen. Esperar a
   * DOMContentLoaded llegaria DESPUES de que los demas bundles registren sus
   * propios listeners de submit, y el orden de registro es lo que decide si el
   * campo `antibot_token` esta puesto a tiempo para su FormData.
   *
   * La rama de DOMContentLoaded es solo la red para una carga no diferida; ahi
   * el orden no esta garantizado, por eso saas-auth.js llama ademas a attach()
   * explicitamente antes de registrar el suyo (attach es idempotente).
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      autoAttach();
    });
  } else {
    autoAttach();
  }
})();
